import React, { useMemo } from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

import NoImage from '../../../../../../assets/asia-logo.jpeg'

export default function Card({
  title,
  noTitle = 'Title',
  logo,
  isComing = false,
}) {
  const displayTitle = useMemo(() => {
    if (!title) return null

    return title.length > 15 ? title.slice(0, 15) + '...' : title || noTitle
  }, [title, noTitle])

  const cardClassName = useMemo(() => {
    return classNames(styles.card, {
      [styles.isComing]: isComing,
    })
  }, [isComing])

  const imageSrc = useMemo(() => logo || NoImage, [logo])

  const imageWithPlaceHolder = useMemo(
    () => <img src={imageSrc} alt='img' className={styles.gameImage} />,
    [imageSrc]
  )

  return (
    <div>
      <div className={cardClassName}>
        <section className={styles.imageSection}>
          {imageWithPlaceHolder}
        </section>
        <section className={styles.titleSection}>
          {displayTitle && <p>{displayTitle}</p>}
        </section>
      </div>
    </div>
  )
}
